import { getTWA } from './getTWA';

const getUserLanguageCodeFromTWA = (): string | undefined => getTWA().initDataUnsafe.user?.language_code;

export { getUserLanguageCodeFromTWA };
